export default __webpack_public_path__ + "static/MIMG_4940-330-0d38281a4e0780191292ecc1b2412c2b.jpg";